import { Permissions } from '@shared/models/enums/permissions.enum';

export const SIDENAV_MENU = [
  {
    label: '',
    permissions: [null],
    children: [
      {
        label: 'sidebar.home',
        url: '/home',
        activeLink: '/',
        iconName: 'home-icon',
        permissions: [Permissions.All],
      },
    ],
  },
  {
    label: 'sidebar.sections.cms',
    permissions: [Permissions.ViewBookingCms, Permissions.ViewMediaCms],
    children: [
      {
        label: 'sidebar.manage',
        url: '/bookings',
        activeLink: '/bookings/list',
        iconName: 'overview-icon',
        permissions: [Permissions.ViewBookingCms],
      },
      {
        label: 'sidebar.media',
        url: '/media',
        activeLink: '/media',
        iconName: 'media-icon',
        permissions: [Permissions.ViewMediaCms],
      },
      {
        label: 'sidebar.widgets',
        url: '/widgets',
        activeLink: '/widgets',
        iconName: 'widgets',
        permissions: [Permissions.ViewWidgets],
      },
    ],
  },
  {
    label: 'sidebar.sections.analytics',
    permissions: [
      Permissions.ViewReachAnalytics,
      Permissions.ViewReachReportsAnalytics,
      Permissions.ViewExposuresAnalytics,
      Permissions.ViewExposuresReportsAnalytics,
      Permissions.ViewForecastAnalytics,
      Permissions.ViewForecastEventAnalytics,
    ],
    children: [
      {
        label: 'sidebar.reach',
        url: '/statistics/reach',
        activeLink: '/statistics/reach/',
        iconName: 'reach-icon',
        permissions: [Permissions.ViewReachAnalytics, Permissions.ViewReachReportsAnalytics],
      },
      {
        label: 'sidebar.campaign',
        url: '/statistics/campaign',
        activeLink: '/statistics/campaign',
        iconName: 'exposures-icon',
        permissions: [Permissions.ViewExposuresAnalytics, Permissions.ViewExposuresReportsAnalytics],
      },
      {
        label: 'sidebar.forecast',
        url: '/statistics/forecast',
        activeLink: '/statistics/forecast',
        iconName: 'forecast-icon',
        permissions: [Permissions.ViewForecastAnalytics, Permissions.ViewForecastEventAnalytics],
      },
    ],
  },
  {
    label: 'sidebar.sections.visitorInsights',
    permissions: [
      Permissions.ViewPeopleCounterInsights,
      Permissions.ViewPeopleCounterReportsInsights,
      Permissions.ViewPoiInsights,
      Permissions.ViewPoiCategoriesInsights,
      Permissions.ViewPoiReportsInsights,
    ],
    children: [
      {
        label: 'sidebar.peopleCount',
        url: '/statistics/people-count',
        activeLink: '/statistics/people-count',
        iconName: 'people-counter-icon',
        permissions: [Permissions.ViewPeopleCounterInsights, Permissions.ViewPeopleCounterReportsInsights],
      },
      {
        label: 'sidebar.poi',
        url: '/person-of-interest',
        activeLink: '/person-of-interest',
        iconName: 'poi-icon',
        permissions: [Permissions.ViewPoiInsights, Permissions.ViewPoiCategoriesInsights, Permissions.ViewPoiReportsInsights],
      },
    ],
  },
];
